<template>
  <div class="col-xl-8 mx-auto">
    <div>
    <h3><b class="text-lg-center">Frequently Asked Questions</b></h3>
        <br />
    <b-table striped :items="questionsAndAnswers" :fields="fields" class="table-light">
    </b-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'faq',
  data() {
    return {
        fields: [
          { key: 'question' , label: 'QUESTION', sortable: true },
          { key: 'answer' , label: 'ANSWER', sortable: false }
        ],
        questionsAndAnswers: [
            { question: 'Does everyone in my office have to register for a user name/password or can we use the same one? ', answer: 'No - users in your office may share the same account name and password.' },
            { question: 'I am already registered with a user name/password on another portal. Do I have to create a new account for the Manage Ownership Platform?', answer: 'Yes. The Manage Ownership Platform is completely separate from all other portals.' },
            { question: 'I was asked to submit ownership for multiple entities which does not involve a change. What would be the purpose of my NJCRIB ERM-14 Form?', answer: 'The selection to make is \'Determination of Combinability\'. This will allow the Bureau to conclude if multiple entities comprise a single risk.' },
            { question: 'Can I submit an NJCRIB ERM-14 Form on behalf of the insured if I am the agent?', answer: 'Yes, but if you are not the producer of record on the current policy, you should attach a letter of authority signed by the insured on the employer\'s letterhead with your submission.' },
            { question: 'Can I submit more than one type of transaction on the same NJCRIB ERM-14 Form?', answer: 'No. Multiple submissions of the form are necessary for multiple transactions.'}
        ]        
    } 
  }
}
</script>